import { render } from "./make-purchase.vue?vue&type=template&id=18342d6a"
import script from "./make-purchase.vue?vue&type=script&lang=js"
export * from "./make-purchase.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__